// src/Homepage.tsx
import React from 'react';
import './HowItWorks.css';
import HeaderComponent from '../../components/HeaderComponent';

const HowItWorks: React.FC = () => {

  return (
    <div className="homepage">
      <HeaderComponent />
      <div className="card-searchx">
        <h3>How to use search?
        </h3>
        <p>There are two ways to use search:</p>
        <ol>
            <li>Using Search Bar: <br /> Simply write the domain name, category or language in search bar and press search. 
            Note that searches are sensitive to case and spellings</li>
            <li>
                Using Search by tags: <br />
                Here using the drop down box, select the appropriate filters that you want to apply and press apply filter. 
                Press clear filter to remove all filters. Note that clicking on search bar will clean all filters and use query from search bar
            </li>
        </ol>
        <p> Once the search is succesfull results are displayed as a list. 
            Click on "more info" of a particular domain model to get more info about it</p>
      </div>
      <div className="card-searchx">
        <h3>How to use publish domain model?
        </h3>
        <p>Click on publish domain tab from navbar. Fill in the fields. 
            For sake of completeness is it requested to complete the entire form, but submit button will also work with required queries.</p>
        <ol>
            <li>Score Info <br /> If no fields are selected, the default min score will be 2. 
            Even if one field is selected, the form is understood to be complete and score will be computed accordingly.</li>
            <li>
                Parsing domain: <br />
                If language apart from "other" is selected, the domain model will be parsed. 
                he parsing result along with scored will be displayed as pop-up. <br />
                For "others" parsing value is false as no check can be performed at the moment.
                </li>
        </ol>
      </div>
    </div>
  );
};

export default HowItWorks;
